<template>
    <div class="TopicsTopEntrance">
        <div class="TopicsTopEntrance-header">
            <div>公共弹幕管理/详情</div>
            <div>
                <el-button type="primary" @click="submitForm">保存</el-button>
                <el-button type="primary" @click="$router.go(-1)">返回</el-button>
            </div>
        </div>
        <el-form label-width="120px" :model="queryForm" style="width: 560px;">
            <el-form-item label="弹幕内容">
                <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="queryForm.content" style="width: 100%;">
                </el-input>
            </el-form-item>
            <el-form-item label="弹幕类目">
                <el-select v-model="queryForm.categoryId" placeholder="请选择状态" style="width: 100%;">
                    <el-option v-for="(item, index) in categoryOption" :key="index" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="初始试用次数">
                <el-input-number v-model="queryForm.initialization" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
            <el-form-item label="弹幕排序">
                <el-input-number v-model="queryForm.sort" :min="1" style="width: 100%;"></el-input-number>
            </el-form-item>
            <el-form-item label="字体颜色选择">
                <div style="display: flex;align-items: center;">
                    <el-color-picker v-model="queryForm.textColor"></el-color-picker>
                    <el-input v-model="queryForm.textColor" style="flex: 1;margin-left: 12px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="背景开始渐变色">
                <div style="display: flex;align-items: center;">
                    <el-color-picker v-model="queryForm.startColor"></el-color-picker>
                    <el-input v-model="queryForm.startColor" style="flex: 1;margin-left: 12px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="背景结束渐变色">
                <div style="display: flex;align-items: center;">
                    <el-color-picker v-model="queryForm.endColor"></el-color-picker>
                    <el-input v-model="queryForm.endColor" style="flex: 1;margin-left: 12px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="渐变角度">
                <el-input-number v-model="queryForm.angle" :min="-360" :max="360" style="width: 100%;"></el-input-number>
            </el-form-item>
            <el-form-item label="背景色预览">
                <div style="width: 100%;height: 36px;"
                    :style="{ 'background': `linear-gradient(${queryForm.angle + 90}deg, ${queryForm.startColor}, ${queryForm.endColor})` }">
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            queryForm: {
                content: "",
                categoryId: "",
                initialization: 0,
                sort: 1,
                textColor: '',
                startColor: '',
                endColor: '',
                angle: 0
            },
            categoryOption: [],
        }
    },
    mounted() {
        this.apiGetCategoryOptions()
        this.apiGetBarrageDetail()
    },
    methods: {
        apiGetCategoryOptions() {
            this.$http({
                url: this.$util.domain + '/adminapi/barrage/category/select/list',
                method: 'GET',
            }).then(res => {
                if (res.body.error === 10000) {
                    if (res.body.data && res.body.data.length) {
                        this.categoryOption = res.body.data.map(item => ({
                            label: item.name,
                            value: item.id
                        }))
                    } else {
                        this.categoryOption = []
                    }
                } else {
                    this.categoryOption = []
                    this.$util.errorMsg(res.body.message);
                }
            })
        },
        apiGetBarrageDetail() {
            if (!this.$route.query.barrageId) {
                return
            }
            this.$http({
                url: this.$util.domain + '/adminapi/barrage/public/barrage/detail',
                method: 'GET',
                params: {
                    barrageId: this.$route.query.barrageId
                }
            }).then(res => {
                if (res.body.error === 10000) {
                    if (res.body.data && JSON.stringify(res.body.data) !== '{}') {
                        this.queryForm = res.body.data
                    } else {
                        this.queryForm = {
                            content: "",
                            categoryId: "",
                            initialization: 0,
                            sort: 1,
                            textColor: '',
                            startColor: '',
                            endColor: '',
                            angle: 0
                        }
                    }
                } else {
                    this.queryForm = {
                        content: "",
                        categoryId: "",
                        initialization: 0,
                        sort: 1,
                        textColor: '',
                        startColor: '',
                        endColor: '',
                        angle: 0
                    }
                    this.$util.errorMsg(res.body.message);
                }
            })
        },
        submitForm() {
            this.$http({
                method: 'POST',
                url: this.$util.domain + '/adminapi/barrage/public/barrage/add',
                body: JSON.stringify({
                    ...this.queryForm
                })
            }).then(res => {
                if (res.body.error === 10000) {
                    this.$util.successMsg('操作成功');
                    this.$router.go(-1)
                } else {
                    this.$util.errorMsg(res.body.message);
                }
            }).catch(() => {
                this.$util.errorMsg('服务器内部错误');
            })
        }
    }
}
</script>

<style scoped>
.TopicsTopEntrance {
    display: flex;
    flex-direction: column;
}

.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?56ee2b8b